import { Grid } from '@mui/material'
import VuiBox from "components/VuiBox";
import * as S from "./style";

const VersionContainer = ({ version, releases }) => (
  <S.VersionsTableContainer>
    <S.TableTitle>
      Viraliza Official {version}
    </S.TableTitle>
    <S.VersionsTable container>
      <S.TableHeader container>
        <Grid item xs={2}>
          <S.HeaderContent>Versão</S.HeaderContent>
        </Grid>
        <Grid item xs={7}>
          <S.HeaderContent>Notas de lançamento</S.HeaderContent>
        </Grid>
        <Grid item xs={3}>
          <S.HeaderContent align="center">Data de lançamento</S.HeaderContent>
        </Grid>
      </S.TableHeader>
      {releases.reverse().map((release, index) => (
        <S.TableBody container key={index}>
          <Grid item xs={2}>
            <S.BodyContent>
              {release.version}
            </S.BodyContent>
          </Grid>
          <Grid item xs={7}>
            <VuiBox>
              {release.notes.map((note, index) => (
                <S.NoteContent key={index}>
                  {note}
                </S.NoteContent>
              ))}
            </VuiBox>
          </Grid>
          <Grid item xs={3}>
            <S.BodyContent align="center">
              {release.date}
            </S.BodyContent>
          </Grid>
        </S.TableBody>
      ))}
    </S.VersionsTable>
  </S.VersionsTableContainer>
);

const Versions = () => {
  const releases18 = [
    {
      version: "1.8.0",
      notes: [
        "A Whole New World!"
      ],
      date: "15 de Julho de 2025"
    },
    {
      version: "1.8.1",
      notes: [
        "Correções e Melhorias"
      ],
      date: "10 de Setembro de 2025"
    },
    {
      version: "1.8.2",
      notes: [
        "Melhorias em Projetos"
      ],
      date: "22 de Setembro de 2025"
    }
  ];

  const releases17 = [
    {
      version: "1.7.1",
      notes: ["Nova versão da plataforma com correções de segurança e melhorias."],
      date: "04 de Fevereiro de 2025"
    },
    {
      version: "1.7.2",
      notes: [
        "Criativos de projetos aceitam agora mais de um influencer.",
        "Atividades de produção agora listadas em detalhamento do projeto.",
        "Melhorias nos inputs de cards em pipelines."
      ],
      date: "04 de Março de 2025"
    },
    {
      version: "1.7.3",
      notes: [
        "Correções e melhorias.",
        "Nova página: Histórico de Versões."
      ],
      date: "18 de Março de 2025"
    },
    {
      version: "1.7.4",
      notes: [
        "Novo sistema de carteira do influencer (transferência removida).",
        "Atualização em permissões de agenda",
        "Aba de Orçamento liberada em detalhamento de projeto."
      ],
      date: "18 de Abril de 2025"
    },
    {
      version: "1.7.5",
      notes: [
        "Melhorias em finanças.",
        "Adicionado data de criação em empresa.",
        "Criado ramos de vestuário e apostas."
      ],
      date: "08 de Maio de 2025"
    },
    {
      version: "1.7.6",
      notes: [
        "Melhorias financeiras para o Influencer.",
        "SandBox do TikTok.",
        "Adicionado filtro de ordenação para 'Clientes'."
      ],
      date: "16 de Maio de 2025"
    },
   {
      version: "1.7.7",
      notes: [
        "Correções e Melhorias"
      ],
      date: "28 de Maio de 2025"
    },
    {
      version: "1.7.8",
      notes: [
        "Gráfico de lucro geral adicionado",
        "Automação de Finanças/Saque",
        "Integração de SubLeads."
      ],
      date: "10 de Junho de 2025"
    },
    {
      version: "1.7.9",
      notes: [
        "Atualizações de Marketing"
      ],
      date: "17 de Junho de 2025"
    }
  ];
  
  return (
    <S.MainContainer container flexDirection='column' gap='20px'>
      <Grid>
        <p className='title'>Histórico de versões</p>
      </Grid>
      <Grid>
        <p className='lastUpdate'><i>Última atualização: 22/09/2025</i></p>
      </Grid>
      <Grid>
        <p className='description'>A tabela a seguir descreve as alterações importantes em cada versão do sistema após <span style={{ fontWeight: "700" }}>Fevereiro de 2025</span>. Para receber notificações sobre atualizações dessa documentação, acesse sua dashboard.</p>
      </Grid>
      
      <VersionContainer version="1.8" releases={releases18} />
      <VersionContainer version="1.7" releases={releases17} />
    </S.MainContainer>
  );
};

export default Versions;
